export const EVENTS = {
  VIEW_STORE: "web_view_store",
  VIEW_PRODUCT: "web_view_product",
  SELECT_ADD_PRODUCT: "web_select_add_product",
  ERROR_CREATE_ORDER: "web_send_order_error",
  SELECT_ADD_PRODUCT_QUANTITY: "web_select_add_product_quantity",
  SELECT_SUBSTRACT_PRODUCT_QUANTITY: "web_select_substract_product_quantity",
  SELECT_CONTACT_VENDOR: "web_select_contact_vendor",
  SELECT_STORE_REVIEWS: "web_select_store_reviews",
  SELECT_VIEW_CART: "web_select_view_cart",
  SELECT_INPUT_NAME: "web_select_input_name",
  SELECT_INPUT_PHONE: "web_select_input_phone",
  SELECT_SHIPPING_METHOD: "web_select_shipping_method",
  SELECT_STORE_PICKING_METHOD: "web_select_store_picking_method",
  SELECT_MAP_LOCATION: "web_select_map_location",
  SELECT_INPUT_DELIVERY_ADDRESS: "web_select_input_delivery_address",
  SELECT_INPUT_DELIVERY_ADDRESS_DETAIL:
    "web_select_input_delivery_address_details",
  SELECT_SEND_ORDER: "web_select_send_order",
  CLICK_REWARDS: "web_click_to_rewards",
  PAY_NOW: "view_pay_now",
  SELECT_PAY_NOW: "select_pay_now",
  SELECT_PAYMENT_UPON_DELIVERY: "select_payment_upon_delivery",
  SELECT_PAYMENT_PHONE_NUMBER: "select_payment_phone_number",
  SELECT_INPUT_NAME_PAYMENT: "select_input_name_payment",
  SELECT_INPUT_ADDRESS_PAYMENT: "select_input_address_payment",
  SELECT_INPUT_EMAIL_PAYMENT: "select_input_email_payment",
  SELECT_INPUT_ID_TYPE_PAYMENT: "select_input_id_type_payment",
  SELECT_INPUT_ID_NUMBER_PAYMENT: "select_input_id_number_payment",
  SELECT_INPUT_PREFIX_PHONE_PAYMENT: "select_input_prefix_phone_payment",
  SELECT_INPUT_PHONE_PAYMENT: "select_input_phone_payment",
  SELECT_PAY_WITH_CARD: "select_pay_with_card",
  SELECT_PAY_WITH_BANK_TRANSFER: "select_pay_with_bank_transfer",
  SELECT_PAY_WITH_BANK_NAME: "select_input_bank_name",
  SELECT_PAY_TRANSFER: "select_pay_transfer",
  SELECT_PAY_IN_VENUE: "select_pay_in_venue",
  SELECT_VENUE: "select_venue",
  SELECT_PAY_VENUE: "select_pay_venue",
  SYSTEM_LINK_PAYED: "system_link_payed",
  SYSTEM_LINK_PAYMENT_ERROR: "system_link_payment_error",
};
